//                                                  
//                                                                        
//                                                                   
import { repo } from '@bi/sync';
//                                                                         
export const ConfigsRepository = repo.ds.ConfigsRepository;
export const UnitsRepository = repo.ds.UnitsRepository;
export const MetricsRepository = repo.ds.MetricsRepository;
export const MetricSetsRepository = repo.ds.MetricSetsRepository;
export const LocationsRepository = repo.ds.LocationsRepository;
export const PeriodsRepository = repo.ds.PeriodsRepository;
export const DashboardTopicsRepository = repo.ds.DashboardTopicsRepository;
export const DashboardsRepository = repo.ds.DashboardsRepository;
export const DashletsRepository = repo.ds.DashletsRepository;
export const AttachmentsRepository = repo.ds.AttachmentsRepository;
export const ResourcesRepository = repo.ds.ResourcesRepository;
export const TextDataRepository = repo.ds.TextDataRepository;
export const DataSourcesRepository = repo.ds.DataSourcesRepository;
export const CubesRepository = repo.ds.CubesRepository;
export const DimensionsRepository = repo.ds.DimensionsRepository;
export const VarsRepository = repo.ds.VarsRepository;
